import { pxToRem } from "@/util";
import { Box } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Consult from "@/components/consultation/consultProcess";
import { next } from "@/util/data/serviceData";
import { AppColors } from "@/assets/colors";
import Header from "../home/header";

export default function Next() {
  const { classes } = styles();
  return (
    <Box className={classes.container}>
      <Box className={classes.detCont}>
        <Header
          isAction={false}
          name="What Happens Next?"
          description="We make the consultation process simple and seamless. Here’s what you
          can expect after scheduling your session with AREL."
        />
      </Box>
      <Box className={classes.consultProcess}>
        {next.map((item, index) => (
          <Consult
            key={index}
            image={item.image}
            title={item.title}
            description={item.description}
          />
        ))}
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
    background: AppColors.neutral["100"],
    borderRadius: pxToRem(8),
  },
  detCont: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  head: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(48),
    color: "#000929",
  },
  desc: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: "#000929",
  },
  consultProcess: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing(4),
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(20)} ${pxToRem(15)}`,
    },
  },
}));
